import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import withData from 'util/hoc/with-data';
import HiringQuery from 'apps/hiring/util/query';

class BrowseTargetsModal extends React.Component {
  state = {
    saving: false
  }

  static defaultProps = {
    onTargets: ()=>{},
    exclude: [],
    addLabel: 'ADD'
  }

  static getDerivedStateFromProps (nextProps) {
    const ids = [];
    nextProps.activeTargets.map(x => {ids.push(x.id)});
    return {
      targets: resolve(nextProps, 'graph_data/targets', []).filter(({id})=>nextProps.exclude.findIndex(v=>v.id==id)==-1).filter(x => !ids.includes(x.id))
    };
  }

  mapTargets = ({ id, name }) => (
    <div className="hiring-behavior-row">
      <span>
        { name }
      </span>
      <div>
        <button onClick={()=>this.add(id)} disabled={this.state.saving}>{this.props.addLabel||'ADD'}</button>
      </div>
    </div>
  )

  add = async (id) => {
    this.setState({
      saving: true
    });
    await this.props.onTargets([this.state.targets.find(v=>v.id===id)]);
    this.setState({
      saving: false
    });
  }

  render() {
    const {
      graph_data,
      graph_loading,
      activeTargets
    } = this.props;

    return (
      <div className="hiring-modal">
        <div className="hiring-modal-header">
          <div className="hiring-modal-header-inner">
            <p>Browse Targets</p>
            <a onClick={this.props.onClose} href="javascript:void(0)">×</a>
          </div>
          <svg className="hiring-modal-header-svg" width="100%" height="20px" viewBox="0 0 100 50" preserveAspectRatio="none">
            <path className="hiring-modal-header-svg-first" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 100,50 0,0`}></path>
            <path className="hiring-modal-header-svg-second" fill="currentColor" strokeWidth="0" d={`M0,0 100,0 0,50 0,0`}></path>
          </svg>
        </div>
        <div className="hiring-modal-body">
          {
            graph_loading
              ? <h1>Loading</h1>
              : (
                this.state.targets.length
                  ? this.state.targets.map(this.mapTargets)
                  : <h1>Create New Target</h1>
              )
          }
        </div>
      </div>
    );
  }
}

BrowseTargetsModal.parseQueryData = (data) => ({
  targets: resolve(data, 'organization/target_groupings/results', []),
  pagination: resolve(data, 'organization/target_groupings/pagination', {})
});

BrowseTargetsModal.query = (token) => (
  HiringQuery(`
    {
      organization {
        target_groupings (limit: 100) {
          pagination {
            limit,
            total,
            offset
          }
          results {
            name,
            id,
            finalized
          }
        }
      }
    }
  `)
);

export default withData(BrowseTargetsModal);
